var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUxdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M649.55 406.38l158.5 159.05 18.13-18.08-158.55-159.11 44.87-45.03 158.61 159.15 18.13-18.07-158.66-159.22 143.44-143.94H765.58l-89.22 89.53-157.48-158.03-18.14 18.07 157.54 158.1-44.88 45.03-157.59-158.14-18.13 18.07 157.65 158.21-93.02 93.34-263.27-264.18H130.6l317.49 318.6-317.49 318.6h108.44l263.27-264.2 263.28 264.2h108.43l-317.49-318.6 93.02-93.35z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxdIcon);
export default __webpack_public_path__ + "static/media/UXD-icon.3c8f1f1a12404713b0b81fdd088ea30e.svg";
export { ForwardRef as ReactComponent };